import React from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"
import moment from "moment"

import {
  INTERFACE_ONLINE_BUTTON_RESCHEDULE,
  INTERFACE_ONLINE_BUTTON_CANCEL_SCHEDULE,
  INTERFACE_ONLINE_BUTTON_INTERRUPT_SCHEDULE
} from "shared/constants/idsElements"
import DefaultContainer from "shared/components/DefaultContainer"
import ModernButton from "shared/components/Button/ModernButton"
import Typograph from "components/Typograph"
import WrapperSkeleton from "components/WrapperSkeleton"

import styles from "./styles.css"

import { maskTel } from "services/utils/mask"

moment.locale("pt-br")

const Schedule = ({
  t,
  detailsIsOpen,
  details,
  schedule,
  interruptIsOpen,
  cancelIsOpen,
  onClickReschedule,
  loading
}) => {
  const targetPhoneList = detailsIsOpen
    ? details.targetPhoneList
    : schedule.targetPhoneList

  const isBeforeStartDate = moment().isBefore(moment(schedule.startDate))

  return (
    <WrapperSkeleton path="scheduleOnlineInterface" isChildrenReady={!loading}>
      <DefaultContainer
        customClass={`Grid-cell u-flex u-flexCol ${styles.scheduleContainer}`}
      >
        <div className={styles.dates}>
          <Typograph
            classNames={styles.startDate}
            htmlTag="p"
            size="small"
            weight="regular"
            color="outer_space"
          >
            {`${t("MSG_0182")}: `}
            <span>{moment(schedule.startDate).format("DD/MM/YYYY HH:mm")}</span>
          </Typograph>
          <div className={styles.piped} />
          <Typograph
            classNames={styles.endDate}
            htmlTag="p"
            size="small"
            weight="regular"
            color="outer_space"
          >
            {`${t("DATE_FINISHED")}: `}
            <span>{moment(schedule.endDate).format("DD/MM/YYYY HH:mm")}</span>
          </Typograph>
        </div>

        <table className={styles.tableSchedule}>
          <tbody>
            <tr className={styles.listSchedule}>
              <td className={styles.listTitle}>{t("REGENERATED_NUMBER")}</td>
              <td className={styles.listTitle}>
                {t("PERCENTAGE_REDIRECTION")}
              </td>
            </tr>
            {Array.isArray(targetPhoneList) &&
              _map(targetPhoneList, (item) => (
                <tr key={item.phoneNumber}>
                  <td>{maskTel(item.phoneNumber)}</td>
                  <td>{`${item.percentage}%`}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className={styles.actions}>
          <ModernButton
            id={INTERFACE_ONLINE_BUTTON_RESCHEDULE}
            shape="outline"
            size="small"
            buttonColor="deep_sea_green"
            text={t("RESCHEDULE")}
            textColor="deep_sea_green"
            textSize="small"
            onClick={onClickReschedule}
            withBorderRadius
          />
          {isBeforeStartDate ? (
            <ModernButton
              id={INTERFACE_ONLINE_BUTTON_CANCEL_SCHEDULE}
              shape="full"
              size="large"
              buttonColor="deep_sea_green"
              text={t("CANCEL_SCHEDULE")}
              textColor="white"
              textSize="small"
              onClick={cancelIsOpen}
              withBorderRadius
            />
          ) : (
            <ModernButton
              id={INTERFACE_ONLINE_BUTTON_INTERRUPT_SCHEDULE}
              shape="full"
              size="large"
              buttonColor="deep_sea_green"
              text={t("INTERRUPT_SCHEDULE")}
              textColor="white"
              textSize="small"
              onClick={interruptIsOpen}
              withBorderRadius
            />
          )}
        </div>
      </DefaultContainer>
    </WrapperSkeleton>
  )
}

Schedule.propTypes = {
  t: PropTypes.func.isRequired,
  schedule: PropTypes.object,
  detailsIsOpen: PropTypes.bool,
  details: PropTypes.object,
  cancelIsOpen: PropTypes.func,
  interruptIsOpen: PropTypes.func,
  onClickReschedule: PropTypes.func,
  loading: PropTypes.bool
}

export default Schedule



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/Schedule/index.js